import { render, staticRenderFns } from "./speechTreeDetail.vue?vue&type=template&id=2db6a7cf&scoped=true&"
import script from "./speechTreeDetail.vue?vue&type=script&lang=js&"
export * from "./speechTreeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db6a7cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db6a7cf')) {
      api.createRecord('2db6a7cf', component.options)
    } else {
      api.reload('2db6a7cf', component.options)
    }
    module.hot.accept("./speechTreeDetail.vue?vue&type=template&id=2db6a7cf&scoped=true&", function () {
      api.rerender('2db6a7cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/answer/commonSpeech/detail/speechTreeDetail.vue"
export default component.exports